import {
  getTransactionListings,
  transactionsListings,
} from 'src/common/helpers/transaction-helper';
import { IDataInformation } from 'src/common/interfaces/dtos/IDataInformation';
import { IItemInputData } from 'src/common/interfaces/IItemInputData';
import { recallTransaction } from 'src/search-transactions/business-logic/recall-transaction';
import { searchForTransactions } from 'src/transaction-search/business-logic/service/search-for-transactions';
import { transactionNotFoundErrorModal } from 'src/transaction-search/error-modals/search-transaction-modals';
import {
  TlogTransactionType,
  TransactionSearchDto,
} from 'src/transaction-search/interfaces/transaction-search-response';
import { transactionOptionsModal } from 'src/transaction-search/transaction-search-helper/transaction-options-helper';

export const transactionAdd = async (
  inputData: IItemInputData,
  dataInformation: IDataInformation,
): Promise<void> => {
  const listingParams: transactionsListings = {
    scanData: dataInformation.scanData,
  };
  const searchParams: TransactionSearchDto = {
    touchPointId: dataInformation.touchPointId,
    transactionNumber: dataInformation.id,
    businessDayUtc: dataInformation.issueDate,
  };
  // Checking the tlog of the searched transaction for 3 different flows. Recall, Void, or TBR/Reprint.
  const transactionSearch = await searchForTransactions(searchParams);
  if (transactionSearch.pageContent.length > 0) {
    const [transactionContentData] = transactionSearch.pageContent;
    const tenderExchangeTransaction =
      transactionContentData.transactionType === TlogTransactionType.TENDER_EXCHANGE;
    if (transactionContentData.isSuspended) {
      // Returning error if the suspended transaction cannot be found in SE due to retention policy of 24 hours.
      return getTransactionListings(listingParams)
        .catch(() => {
          throw transactionNotFoundErrorModal;
        })
        .then(foundTransaction =>
          recallTransaction(
            foundTransaction[0].transactionId,
            false,
            foundTransaction[0].touchPointId,
            foundTransaction[0].cartReference,
          ),
        );
    } else if (transactionContentData.isVoided) {
      throw transactionNotFoundErrorModal;
    } else {
      transactionOptionsModal(inputData, dataInformation, tenderExchangeTransaction);
    }
  } else {
    throw transactionNotFoundErrorModal;
  }
};
